import React from "react";

export default function FloatingWhatsappButton() {
  const whatsappLink ="https://whatsapp.com/channel/0029Vb624Xx4inoky9MAGB2n"
  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-12 right-12 z-50"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="Join WhatsApp"
        className="w-16 h-16 animate-pulse bg-white rounded-full shadow-lg p-2"
      />
    </a>
  );
}
